import { configureStore } from '@reduxjs/toolkit'
import { persistCombineReducers, persistStore, createTransform } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// TODO: This shouldn't run in prod
// eslint-disable-next-line import/no-extraneous-dependencies
import { devToolsEnhancer } from '@redux-devtools/extension'

import userReducer from './redux/userSlice'
import moduleReducer from './redux/moduleSlice'
import moduleDataReducer from './redux/moduleDataSlice'
import userNotificationReducer from './redux/userNotificationSlice'
import dropdownReducer from './redux/dropdownSlice'
import modalReducer from './redux/modalSlice'
import notificationReducer from './redux/notificationSlice'
import authReducer from './redux/authSlice'
import layoutReducer from './redux/layoutSlice'
import portfolioReducer from './redux/portfolioSlice'
import rerenderReducer from './redux/rerenderSlice'
import multiSelectRowReducer from './redux/multiSelectRowSlice'
import paymentSchedulePanelReducer from './redux/paymentSchedulePanelSlice'
import paymentScheduleDataReducer from './redux/paymentScheduleDataSlice'
import simulatedDateReducer from './redux/simulatedDateSlice'
// Strip needsRefresh from simulatedDate when persisting; reset to false on rehydrate
const simulatedDateTransform = createTransform(
  (inboundState) => {
    const { needsRefresh, ...rest } = inboundState
    return rest
  },
  (outboundState) => ({
    ...outboundState,
    needsRefresh: false,
  }),
  { whitelist: ['simulatedDate'] }
)

// Controls Redux Local Storage Caching. Don't add anything to whitelist unless it needs to persist across refresh.
const persistConfig = {
  timeout: 500,
  key: 'root',
  version: 1,
  storage,
  whitelist: ['user', 'modules', 'dropdowns', 'portfolios', 'simulatedDate'],
  transforms: [simulatedDateTransform],
}

// Combine Reducers into one high level Reducer. Add all Redux Reducers here
const persistedReducer = persistCombineReducers(persistConfig, {
  user: userReducer,
  modules: moduleReducer,
  moduleData: moduleDataReducer,
  dropdowns: dropdownReducer,
  portfolios: portfolioReducer,
  notification: notificationReducer,
  auth: authReducer,
  layout: layoutReducer,
  modal: modalReducer,
  userNotification: userNotificationReducer,
  rerender: rerenderReducer,
  multiSelectRow: multiSelectRowReducer,
  paymentSchedulePanel: paymentSchedulePanelReducer,
  paymentScheduleData: paymentScheduleDataReducer,
  simulatedDate: simulatedDateReducer
})

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }),
  devTools: false,
  enhancers: [devToolsEnhancer()],
})

export const persistor = persistStore(store)
export default store
